const COOKIE_KEYS = {
  amplitudeDeviceId: 'amp_device_id',
  cartId: 'cartId',
  csrf: 'XSRF-TOKEN',
  curologyUuid: 'curologyUuid',
  funnelId: 'funnelId',
  hasTrackingOptedOut: 'trackingOptOut',
  inviteToken: 'inviteToken',
  isOtcSignupUser: 'isOtcSignupUser',
  landingUrl: 'landingUrl',
  ldUuid: 'ldUuid',
  nextSessionId: 'nextSessionId',
  offer: 'offer',
  offerSource: 'offerSource',
  referrerUrl: 'referrerUrl',
  sAccessToken: 'sAccessToken',
} as const;

export type CookieKeyType = valueof<typeof COOKIE_KEYS>;

export default COOKIE_KEYS;
